import { nextTick } from 'vue';

export function useHandleSpace() {
  const handleSpace = (e, stateRefMap) => {
    const el = e.target;
    const position = el.selectionStart + 1;
    const key = el.name;

    if (stateRefMap[key]) {
      const val = stateRefMap[key].value;
      stateRefMap[key].value =
        val.slice(0, position - 1) + ' ' + val.slice(position - 1);
    }

    nextTick(() => {
      el.setSelectionRange(position, position);
    });
  };

  const handleDDSpace = (e) => {
    const el = e.target;
    const position = el.selectionStart + 1;
    el.value =
      el.value.slice(0, position - 1) + ' ' + el.value.slice(position - 1);

    nextTick(() => {
      el.setSelectionRange(position, position);
    });
  };

  const filterOption = (input, option) => {
    return option.label?.toLowerCase().includes(input.toLowerCase());
  };

  return {
    handleSpace,
    handleDDSpace,
    filterOption,
  };
}
